// Get these at runtime and not during build process to avoid carry over from heroku pipeline
export const {
  REACT_APP_BASE_API_URL,
  REACT_APP_PRIVACY_POLICY_URL,
  REACT_APP_STRIPE_PUBLISHABLE_KEY,
} = process.env;
